/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 搜索和分类搜索视频
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: cloundtheater.SearchCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cloundtheater.Page<cloundtheater.VideoDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cloundtheater/search-videos`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
